const Terms = () => {
  return (
    <div className="py-20">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
          
          <div className="prose prose-lg">
            <p className="text-gray-600 mb-8">
              Last updated: March 2024
            </p>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-600 mb-4">
                By accessing or using Civic Guru's services, you agree to be bound by these Terms of
                Service. If you disagree with any part of these terms, you may not access our service.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Service Description</h2>
              <p className="text-gray-600 mb-4">
                Civic Guru is an AI-powered legal assistant that provides general legal information and
                guidance through WhatsApp. Our service is intended for informational purposes only and
                should not be considered as formal legal advice.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. User Responsibilities</h2>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Provide accurate and complete information when using our service</li>
                <li>Maintain the confidentiality of your account information</li>
                <li>Use the service in compliance with applicable laws and regulations</li>
                <li>Not misuse or attempt to manipulate our AI system</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Limitations of Service</h2>
              <p className="text-gray-600 mb-4">
                Our service:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Does not constitute legal advice or create an attorney-client relationship</li>
                <li>May not be suitable for complex legal matters</li>
                <li>Should not be relied upon for making critical legal decisions</li>
                <li>May have limitations in accuracy and completeness</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Intellectual Property</h2>
              <p className="text-gray-600 mb-4">
                All content, features, and functionality of our service are owned by Civic Guru and
                are protected by international copyright, trademark, and other intellectual property laws.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Disclaimer of Warranties</h2>
              <p className="text-gray-600 mb-4">
                Our service is provided "as is" without any warranty of any kind. We do not guarantee
                the accuracy, completeness, or usefulness of any information provided through our service.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Limitation of Liability</h2>
              <p className="text-gray-600 mb-4">
                Civic Guru shall not be liable for any indirect, incidental, special, consequential,
                or punitive damages resulting from your use or inability to use our service.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Changes to Terms</h2>
              <p className="text-gray-600 mb-4">
                We reserve the right to modify these terms at any time. We will notify users of any
                material changes through our service or via email.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Contact Information</h2>
              <p className="text-gray-600 mb-4">
                For questions about these Terms of Service, please contact us at:
              </p>
              <ul className="list-none text-gray-600 space-y-2">
                <li>Email: info@civicguru.app</li>
                <li>Phone: +263 719-709-668</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms; 